import emitter from 'tiny-emitter/instance'

export default {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args)
}

export const eventNames = {
  USER_LOGGED_IN: 'userLoggedIn',
  SHOW_SNACKBAR: 'showSnackbar',
  /** A company lifecycle transition committed; readers should re-read it. */
  COMPANY_STATE_UPDATED: 'companyStateUpdated',
  /**
   * Material generation was (re)started — retry, regenerate, approval, or
   * withdrawal. Screens watching materials restart observation on this rather
   * than waiting for a status they already stopped polling for.
   */
  MATERIAL_WORK_STARTED: 'materialWorkStarted'
}
